import { dataHooks } from '../../../../libs/dataHooks';

export const filtersDropdownContentDataHooks = dataHooks<{
  content: {};
  clearLink: {};
}>('filtersDropdown');
